import React from 'react';

const Home = () => (
  <div className="home">
    <h3>Welcome to our page!</h3>
    <p>
      This is a simple basic calculator with memory functions similar to a small
      handheld calculator. Use this basic calculator online for math with
      addition, subtraction, division and multiplication.
    </p>
  </div>
);

export default Home;
